import { useEffect, useRef, useState } from 'react';
import { useReduxState } from 'hooks';
import { TextInput } from 'components/common/form/common';
import { Icon } from 'components/common/icons';

import { useFiltersDispatch } from './FilterContext';
import type { FilterItem } from '.';

interface Props extends FilterItem {
  filterId: string;
  initialValue?: string;
  onInputChange: (value: string) => void;
  setRootIsOpen: (isOpen: boolean) => void;
}

const FilterButtonOpenInput = ({
  field,
  filterId,
  initialValue,
  onInputChange,
  setRootIsOpen
}: Props) => {
  const { messages, theme } = useReduxState();

  const filterDispatch = useFiltersDispatch();

  const inputRef = useRef<HTMLDivElement>(null);

  const [inputValue, setInputValue] = useState(initialValue || '');

  useEffect(() => {
    const element = document.getElementById(
      `${field}-input`
    ) as HTMLInputElement;
    if (element) element.focus();
  }, []);

  const handleInputClear = () => {
    setInputValue('');
    onInputChange('');
    const element = document.getElementById(
      `${field}-input`
    ) as HTMLInputElement;
    if (element) element.focus();
  };

  const onInputKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (ev) => {
    if (ev.key === 'Enter' && inputValue) {
      filterDispatch({ type: 'submitFilters', filterId });
      setRootIsOpen(false);
    }
  };

  return (
    <div className="wrapper">
      <div className="input" ref={inputRef}>
        <TextInput
          id={`${field}-input`}
          onChange={(ev) => {
            setInputValue(ev.target.value);
            onInputChange(ev.target.value);
          }}
          onKeyDown={onInputKeyDown}
          placeholder={`${messages.commonValue}...`}
          style={{ paddingRight: 35 }}
          type="string"
          value={inputValue}
        />

        {inputValue ? (
          <div className="clear">
            <button
              aria-label={messages.commonClear}
              className="clear-button"
              onClick={handleInputClear}
              type="button"
            >
              <Icon icon="times-circle" />
            </button>
          </div>
        ) : null}
      </div>

      <style jsx>{`
        .input {
          display: flex;
          margin-bottom: 5px;
          max-height: 100%;
          min-width: 260px;
          overflow: hidden;
          padding: 10px 10px 5px;
        }
        .clear-button {
          background-color: transparent;
          border: 0;
          color: #999;
          cursor: pointer;
          font-size: 1.5rem;
          position: absolute;
          right: 16px;
          top: 18px;
          transition: color 0.3s;
          z-index: 5;
        }
        .clear-button:hover,
        .clear-button:focus {
          color: ${theme.textColor};
        }
      `}</style>
    </div>
  );
};

export default FilterButtonOpenInput;
